import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import PartnerEditor from "../../editors/customer/partner";

const Partners: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.PartnersList}
			endpoint={Endpoint.Partners}
			addScreen={{ screen: PartnerEditor, isAllowed: hasPermission(Permission.PartnersAdd) }}
			editScreen={{ screen: PartnerEditor, isAllowed: hasPermission(Permission.PartnersUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.PartnersDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="vatNumber" title={t("vatNumber")} />
			<GridColumn field="commissionPercentage" title={t("commissionPercentage")} filter="numeric" format="{0:n2}" />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default Partners;
